import Noto_Serif_Display_Italic_latin_ext_Woff from '@capturi/assets/fonts/Noto Serif Display/Noto Serif Display latin-ext.woff2'
import Noto_Serif_Display_Italic_latin_Woff from '@capturi/assets/fonts/Noto Serif Display/Noto Serif Display latin.woff2'
import Poppins_Italic from '@capturi/assets/fonts/Poppins/Poppins-Italic.ttf'
import Poppins_Regular from '@capturi/assets/fonts/Poppins/Poppins-Regular.ttf'
import Poppins_Semibold from '@capturi/assets/fonts/Poppins/Poppins-SemiBold.ttf'
import Poppins_Semibold_Italic from '@capturi/assets/fonts/Poppins/Poppins-SemiBoldItalic.ttf'

import { css } from '@emotion/react'

/**
 * https://google-webfonts-helper.herokuapp.com/fonts/rubik?subsets=latin,latin-ext
 */

const globalStyles = css`
@font-face {
  font-family: 'Noto Serif Display';
  font-style: italic;
  font-weight: 700;
  font-stretch: 62.5%;
  font-display: swap;
  src: url('${Noto_Serif_Display_Italic_latin_ext_Woff}') format('woff2');
  unicode-range: U+0100-02BA, U+02BD-02C5, U+02C7-02CC, U+02CE-02D7, U+02DD-02FF, U+0304, U+0308, U+0329, U+1D00-1DBF, U+1E00-1E9F, U+1EF2-1EFF, U+2020, U+20A0-20AB, U+20AD-20C0, U+2113, U+2C60-2C7F, U+A720-A7FF;
}
  
@font-face {
  font-family: 'Noto Serif Display';
  font-style: italic;
  font-weight: 700;
  font-stretch: 62.5%;
  font-display: swap;
  src: url('${Noto_Serif_Display_Italic_latin_Woff}') format('woff2');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;  
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 400;
  font-display: swap;
  font-feature-settings: "ss04" on;
  src: url('${Poppins_Italic}') format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: 'Poppins';
  font-style: italic;
  font-weight: 600;
  font-display: swap;
  font-feature-settings: "ss04" on;
  src: url('${Poppins_Semibold_Italic}') format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 400;
  font-display: swap;
  font-feature-settings: "ss04" on;
  src: url('${Poppins_Regular}') format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

@font-face {
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-display: swap;
  font-feature-settings: "ss04" on;
  src: url('${Poppins_Semibold}') format('truetype');
  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+0304, U+0308, U+0329, U+2000-206F, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;
}

  body {
    background-color: white;
    font-feature-settings: "ss04";
  }
`

export default globalStyles
